<template>
  <button class="submit-button" :class="{isLoading: isLoading}" :disabled="disabled" @click="onClick">
    <span class="submit-button__text" :class="{isLoading}" @click="onClick">{{ text }}</span>
    <SendIcon v-if="icon" class="submit-button__icon" @click="onClick" />
    <Loader class="circle-loader" v-if="isLoading" />
  </button>
</template>

<script>
import Vue from 'vue';
import SendIcon from '@components/svg/send.vue';
import Loader from '@common/circular-loader.vue';
export default Vue.extend({
  components: {SendIcon, Loader},
  name: 'SubmitMessageButton',
  props: {
    text: {
      type: String,
      default: 'Submit',
    },
    icon: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onClick() {
      this.$emit('submit');
    },
  },
});
</script>

<style scoped lang="scss">
.submit-button {
  border: none;
  background: var(--main-red);
  border: 1px solid var(--main-red);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  min-width: 112px;
  height: 50px;
  border-radius: 3px;
  font-weight: normal;
  color: #fff;
  position: relative;
  &__text {
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    white-space: nowrap;
  }
  &__text.isLoading {
    color: transparent;
  }
  &__icon {
    margin-left: 10px;
  }
  &:disabled {
    background-color: var(--light-light-gray);
    color: var(--filter-label-color);
    border: 1px solid var(--light-light-gray);

    &:hover {
      cursor: not-allowed;
    }
  }
  &.isLoading {
    background: var(--main-red);
    color: #fff;
  }
}

.chat-submit {
  position: absolute;
  bottom: 20px;
  right: 20px;
  padding: 0 16px;
}
.chat-submit.inactive.start-over {
  background-color: var(--light-light-gray);
  color: var(--filter-label-color);
  border: 1px solid var(--light-light-gray);

  &:hover {
    cursor: not-allowed;
  }
}
.chat-submit.start-over {
  position: absolute;
  bottom: 20px;
  right: 220px;
  background-color: transparent;
  color: var(--main-red);
  border: 1px solid var(--main-red);
}
.circle-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  --transform-loader: translate(-50%, -50%);
}
</style>
